import { computed, Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { select } from '@ngxs/store';
import { HelpUrls } from '../../../../../common/dto/help-urls';
import { KnowledgeBaseArticleDTOListing } from '../../../../../common/dto/knowledge-base.dto';
import { Language } from '../../../../../common/dto/languages.dto';
import { uuidToReadable } from '../../../../../common/utils/id.utils';
import { AppState } from '../../app.state';
import { WINDOW } from './injection-tokens';

@Injectable()
export class RouteNavigationService {
  private _language = select(AppState.language);

  constructor(
    private _router: Router,
    @Inject(WINDOW) private _window: Window,
  ) {
  }

  public homeUrl = computed(() => HelpUrls._.Home.getAbsoluteUrlWithParams({
    [HelpUrls.params.language]: this._language(),
  }));

  public async goToArticleAsync(article: KnowledgeBaseArticleDTOListing) {
    await this._router.navigateByUrl(this.generateArticleUrl(article));
  }

  public generateArticleUrl(article: KnowledgeBaseArticleDTOListing): string {
    return HelpUrls._.Articles.getAbsoluteUrlWithParams({
      [HelpUrls.params.language]: this._language(),
      [HelpUrls._.Articles.params.articleLink]: article.link ?? uuidToReadable(article.id),
    }).replace(/\/\//g, '/');
  }

  public async goToLanguageAsync(language: Language) {
    this._window.location.href = this._window.location.href.replace(new RegExp(`(/)${ this._language() }(/?)`), `$1${ language }$2`);
  }
}
